import React, { useContext } from "react";
import { Loading, MobileContext } from "components/common";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { convertToShortDate } from "utils";

const BOOST_PAYMENTS_GQL = gql`
query SettingsBoostPayments {
  getUserBoostPayments {
    payments {
      effectiveAt
      billingReason
      amountPaid
    }
  }
}
`;

const billingReasonMap = {
  subscription_create: "Membership Enrollment",
  subscription_cycle: "Membership Renewal",
  subscription_update: "Membership Update",
};

const toThickLine = () => {
  return (
    <hr
      style={{
        height: "2px",
        border: "1px solid #D3D3D3",
        borderRadius: "5px 5px 5px 5px",
        backgroundColor: "#D3D3D3",
      }}
    />
  );
};

const BoostBilling = () => {
  const { isMobile } = useContext(MobileContext);
  const { data: { getUserBoostPayments = {} } = {}, loading } = useQuery(BOOST_PAYMENTS_GQL);
  const { payments = [] } = getUserBoostPayments;

  if (loading) {
    return <Loading boost/>;
  }

  return (
    <div className={`mt-4 w-full inline-grid ${isMobile ? "justify-items-center" : "justify-items-start"}`}>
      <div className="text-l py2">
        <b>History</b>
      </div>
      <div className="w-full">
        {toThickLine()}
      </div>
      {
        payments.length === 0 && (<p>No History</p>)
      }
      {
        payments.map((payment) => {
          const { effectiveAt, billingReason, amountPaid } = payment;
          const paidDate = convertToShortDate(new Date(effectiveAt * 1000));
          const paidAmount = `$${(amountPaid / 100).toFixed(2)}`;
          return (
            <div className="w-full" key={effectiveAt}>
              <div className="flex flex-row justify-between">
                <div className="text-l">
                  <p>{paidDate}</p>
                </div>
                <div className="h-full text-xl mt-4">
                  <p className="text-right">{paidAmount}</p>
                </div>
              </div>
              <p className="pt-2 text-l">{billingReasonMap[billingReason]}</p>
              { toThickLine() }
            </div>
          );
        })
      }
    </div>
  );
};

export default BoostBilling;